import React, { useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import PsychometricTestMainNavbar from './PsychometricTestMainNavbar';
import PsychometricFooter from './PsychometricFooter';
import ErrorBoundary from '../general/ErrorBoundary';

const PsychometricTestAbout = () => {
    const { theme } = useContext(ThemeContext);

    return (
        <div className="psychometric-about">
            <ErrorBoundary errorAt="At Psychometric About Page Navbar">
                <PsychometricTestMainNavbar />
            </ErrorBoundary>

            <div className="container py-5">
                <h1 style={{ 
                    color: '#70B646', 
                    fontSize: 'clamp(2rem, 4vw, 3rem)',
                    textAlign: 'center',
                    ...theme.headingXXL,
                    marginBottom: '2rem'
                }}>
                    About Our Psychometric Testing
                </h1>

                <div style={{
                    ...theme.form,
                    padding: 'clamp(1.5rem, 3vw, 3rem)',
                    maxWidth: '1000px',
                    margin: '0 auto',
                    borderRadius: '10px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}>
                    <section className="mb-5">
                        <h2 style={{ 
                            color: '#70B646',
                            ...theme.headingBold,
                            marginBottom: '1rem'
                        }}>
                            Our Mission
                        </h2>
                        <p style={theme.paragraphText}>
                            At Umang Wellness Psychometric Testing, we provide comprehensive psychometric testing solutions 
                            designed to help both organizations and individuals gain valuable insights 
                            into personality traits, cognitive abilities, and behavioral patterns.
                        </p>
                    </section>

                    <section className="mb-5">
                        <h2 style={{ 
                            color: '#70B646',
                            ...theme.headingBold,
                            marginBottom: '1rem'
                        }}>
                            What We Offer
                        </h2>
                        <ul style={{
                            ...theme.paragraphText,
                            listStyleType: 'none',
                            padding: 0
                        }}>
                            <li className="mb-3">Psychometric Testing for personal use</li>
                            <li className="mb-3">Psychometric Testing representative of an organization</li>
                        </ul>
                    </section>

                    <section>
                        <h2 style={{ 
                            color: '#70B646',
                            ...theme.headingBold,
                            marginBottom: '1rem'
                        }}>
                            Why Choose Us
                        </h2>
                        <p style={theme.paragraphText}>
                            Our platform combines cutting-edge technology with established psychological 
                            principles to deliver accurate, reliable, and meaningful results. Whether 
                            you're an organization looking to enhance your recruitment process or an 
                            individual seeking personal development insights, our psychometric tests 
                            provide valuable data-driven guidance.
                        </p>
                    </section>
                </div>
            </div>

            <PsychometricFooter />
        </div>
    );
};

export default PsychometricTestAbout; 